import $ from "cash-dom";
import { gsap } from "gsap";

export default (function () {
    var selector = "[data-accordion]";

    function init() {
        if (!$(selector).length) return;

        jdmn.log("function_accordion.js initialized", "green");

        var $button = $(selector).find("[data-toggle]");

        $button.off("click");
        $button.on("click", function (_e) {
            var $instance = $(this).parents(selector).eq(0);
            var $body = $instance.find("[data-content]").eq(0);
            var $parent = $body.parent();
            var parentScales = $parent.hasClass("scale-x");
            var $layouts = $body.find(".layouts");

            $button = $(this);
            $button.find("span").toggleClass("on");
            $button.find(".mirror").toggleClass("on");
            $instance.find(".edge").toggleClass("on");

            if ($body[0].style.height) {
                if ($body[0].scrollHeight >= window.innerHeight && !window.chrome) {
                    // window.scrollBy({ top: -$body[0].scrollHeight, behavior: "smooth" });
                }
                $body.css("width", null);
                $body.css("height", null).one("transitionend", function () {
                    $layouts.toggleClass("on");
                    $(window).trigger("heightChange");
                });
                $button.removeClass("on");
            } else {
                $body.css("width", `${$body[0].scrollWidth}px`);
                $body.css("height", `${$body[0].scrollHeight}px`).one("transitionend", function () {
                    $layouts.toggleClass("on");
                    $(window).trigger("heightChange");
                });
                // $button.addClass("on");
                $button.remove();
            }
        });
    }

    $(document).ready(init);
    $(window).on("contentLoaded", init);
})();
